export function SET_CATEGORY({ commit }, [category]) {
    commit('SAVE_CATEGORY', [category])
}

export function SET_DEPARTMENT({ commit }, [department]) {
    commit('SAVE_DEPARTMENT', [department])
}

export function SET_REWARD_USER_POINTS({ commit }, [reward_user_points]) {
    commit('SAVE_REWARD_USER_POINTS', [reward_user_points])
}

export function SET_REWARD_USER_LEVEL({ commit }, [reward_user_level_id, reward_user_level_points]) {
    commit('SAVE_REWARD_USER_LEVEL', [reward_user_level_id, reward_user_level_points])
}